import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { SprayEventWizardState } from './types';

const selectSprayEventWizardState = (state: AppState): SprayEventWizardState =>
    state.sprayEventWizard;

const selectSprayEventWizardStep = createDeepEqualSelector(
    selectSprayEventWizardState,
    sprayEventWizardState => sprayEventWizardState && sprayEventWizardState.step
);

const makeSelectSprayEventWizardStep = (): typeof selectSprayEventWizardStep =>
    selectSprayEventWizardStep;

export {
    selectSprayEventWizardState,
    selectSprayEventWizardStep,
    makeSelectSprayEventWizardStep
};
